import gql from 'graphql-tag';

export const PREDICTION_SURVEY_REPORT = gql`
  query getReportDataForRequestedUsersPredictionSurvey($requestId: ID, $requestedUserId: ID) {
    getReportDataForRequestedUsersPredictionSurvey(requestId: $requestId, requestedUserId: $requestedUserId)
  }
`;
